import React, { useEffect } from 'react'
import { GOOGLE_ADSENSE_CONFIG, shouldDisplayAds, getAdSlotSafely, isValidAdSlot } from '../../config/adsConfig'

interface GoogleAdsProps {
  adSlot: string
  adFormat?: 'auto' | 'rectangle' | 'vertical' | 'horizontal'
  adLayout?: string
  className?: string
  style?: React.CSSProperties
}

const GoogleAds: React.FC<GoogleAdsProps> = ({
  adSlot,
  adFormat = 'auto',
  adLayout,
  className = '',
  style = {}
}) => {
  // Check if we should display ads and if the ad slot is valid
  const safeAdSlot = getAdSlotSafely(adSlot)
  const shouldShow = shouldDisplayAds() && isValidAdSlot(adSlot)

  useEffect(() => {
    if (!shouldShow || !safeAdSlot) return

    try {
      // @ts-ignore
      if (window.adsbygoogle && window.adsbygoogle.loaded) {
        // @ts-ignore
        window.adsbygoogle.push({})
      }
    } catch (error) {
      console.error('Google Ads error:', error)
    }
  }, [shouldShow, safeAdSlot])

  // If ads shouldn't be displayed or ad slot is invalid, show placeholder
  if (!shouldShow || !safeAdSlot) {
    // Only show placeholder in development, not in production
    if (GOOGLE_ADSENSE_CONFIG.testMode) {
      return (
        <div className={`google-ads-container ${className}`} style={style}>
          <div className="ads-placeholder border border-gray-300 rounded-lg p-8 bg-gray-100 text-center">
            <div className="text-sm text-gray-500">
              Ad Preview (Development Mode)
            </div>
            <div className="text-xs text-gray-400 mt-2">
              Ads disabled in development
            </div>
          </div>
        </div>
      )
    }
    // In production, if ad slot is invalid/placeholder, don't show anything
    // This prevents 400 errors from loading placeholder ad slots
    return null
  }

  return (
    <div className={`google-ads-container ${className}`} style={style}>
      <div className="ads-label text-xs text-gray-500 text-center mb-2">
        Advertisement
      </div>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={GOOGLE_ADSENSE_CONFIG.publisherId}
        data-ad-slot={safeAdSlot}
        data-ad-format={adFormat}
        data-ad-layout={adLayout}
        data-full-width-responsive="true"
      />
    </div>
  )
}

export default GoogleAds
